import { render, staticRenderFns } from "./PermissionModal.vue?vue&type=template&id=ad7ccfbc"
import script from "./PermissionModal.vue?vue&type=script&lang=ts"
export * from "./PermissionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports